import { DocumentType } from '@/graphql/generated';

export const DOCUMENT_TYPE_MAP = {
  [DocumentType.AgentReport]: 'Отчет агента',
  [DocumentType.ReconciliationReport]: 'Акт сверки',
  [DocumentType.Upd]: 'УПД',
  [DocumentType.AgentReportPtu]: 'Акт оказанных услуг',
};
